<template>
  <div class="success">
    <img src="../../static/image/success.png" alt="" class="successimg">
    <div class="textcenter font36 c333 mt20">获得取钥匙码</div>
    <div class="textcenter font60 c000 mt20">502279</div>

    <div class="successbtn btncolor c333 font28" style="margin-top: 1.8rem;">知道了</div>
  </div>
</template>

<script>
export default{
  name: 'success'
}
</script>

<style>
  .success{width: 100%;background: #FFFFFF;position: fixed;height: 100%;overflow: hidden;}
  .successimg{width: 3.6rem;height: 3.6rem;display: block;margin: 0 auto;margin-top: 0.66rem;}

</style>



// WEBPACK FOOTER //
// src/view/success.vue